import kebabCase from 'lodash/kebabCase';

/** @return {object} */
export default function createProxy(key) {
  return {
    get() {
      return this[key];
    },
    set(newValue) {
      this.$emit(`update:${kebabCase(key)}`, newValue);
    },
  };
}
